(function ($) {
    $('.news-wrap .filter-search .load-more').on('click', function(e){
        e.preventDefault();
    })

    $(document).on('click', '.blog-landing .filter-nav > ul > li', function(){
        if(!($(this).parents('.filter-inner').hasClass('sort-div'))) {
            $(this).parents('ul').find('li').removeClass('active');
            $(this).addClass('active');
        }
    });
    $(document).on('click', '.blog-landing .filter-nav .sort-div > ul > li', function(){
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $(this).find('ul').slideUp();
        }else{
            $(this).siblings().removeClass("active");
            $(this).addClass('active');
            $(this).find('ul').slideDown();
            $(".blog-landing .filter-nav .sort-div > ul > li").not($(this)).removeClass("active");
            $(".blog-landing .filter-nav .sort-div > ul > li ul").not($(this).find('ul')).slideUp();
        }
    });
    $(document).on('click','.blog-landing .filter-nav .product ul li', function(){
        if(!$(this).hasClass('active')){
            $(this).siblings().removeClass("active");
            $(this).addClass('active');
        }
    });
    $(document).on('click', '.blog-landing .filter-nav .years li', function(){
        if(!$(this).hasClass('active')){
            $(this).siblings().removeClass("active");
            $(this).addClass('active');
        }
    });
    $(document).on('click','body .blog-landing .filter-nav.mobile-filter .filter-inner ul li ul li',function () {
            var $text=$(this).text();
        $(this).parents(".filter-inner").find("span").text($text);
    });
})(jQuery);

